export const defaultForm = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  role: '',
  teamName: '',
  event: '',
  ageGroup: '',
  sport: '',
  numDesigns: '',
  jerseyType: '',
  designNumbers: [],
  color: '',
  font: '',
  comments: '',
  designFiles: [],
  numOrders: '',
  extraQuestions: [],
  nihDate: '',
  referral: '',
  source: '',
};

export const formValidation = {
  firstName: {
    required: {
      value: true,
      message: 'First name is required',
    },
    custom: {
      isValid: value => value.length > 0 && value.length <= 30,
      message: 'First name must be between 1 and 30 characters',
    },
  },
  lastName: {
    required: {
      value: true,
      message: 'First name is required',
    },
    custom: {
      isValid: value => value.length > 1 && value.length <= 40,
      message: 'Last name must be between 2 and 40 characters',
    },
  },
  email: {
    required: {
      value: true,
      message: 'Email is required',
    },
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      message: 'Invalid email address',
    },
  },
  phone: {
    required: {
      value: true,
      message: 'Phone number is required',
    },
    pattern: {
      value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      message: 'Invalid phone number',
    },
  },
  role: {
    required: {
      value: true,
      message: 'Role is required',
    },
  },
  teamName: {
    required: {
      value: true,
      message: 'Team name is required',
    },
    custom: {
      isValid: value => value.length < 50,
      message: 'Team name must be less than 50 characters',
    },
  },
  numOrders: {
    required: {
      value: true,
      message: 'This field is required',
    },
  },
};

export const extraQuestions = {
  baseball: [
    {
      id: '8975060558997380',
      question: 'Would you like to see matching pant designs?',
      options: [
        'Yes (Long Athletic Fit - default)',
        'Yes (Long ProFit - adult sizes only)',
        'Yes (Knickers)',
        'No',
      ],
      value: '',
    },
    {
      id: '677268678829956',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '5165707071645572',
      question: 'Would you like to see matching hat designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  hrd: [
    {
      id: '1474397343010692',
      question: 'Would you like to see matching pant designs?',
      options: [
        'Yes (Long Athletic Fit - default)',
        'Yes (Long ProFit - adult sizes only)',
        'Yes (Knickers)',
        'No',
      ],
      value: '',
    },
    {
      id: '3726197156695940',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '5977996970381188',
      question: 'Would you like to see matching hat designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  warstic: [
    {
      id: '1725996537171844',
      question: 'Would you like to see matching pant designs?',
      options: [
        'Yes (Long Athletic Fit - default)',
        'Yes (Long ProFit - adult sizes only)',
        'Yes (Knickers)',
        'No',
      ],
      value: '',
    },
    {
      id: '3977796350857092',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '6229596164542340',
      question: 'Would you like to see matching hat designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  boa: [
    {
      id: '6980082843029380',
      question: 'Would you like to see matching pant designs?',
      options: [
        'Yes (Long Athletic Fit - default)',
        'Yes (Long ProFit - adult sizes only)',
        'Yes (Knickers)',
        'No',
      ],
      value: '',
    },
    {
      id: '5854182936186756',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  boa2: [
    {
      id: '4814671255392132',
      question: 'Would you like to see matching pant designs?',
      options: [
        'Yes (Long Athletic Fit - default)',
        'Yes (Long ProFit - adult sizes only)',
        'Yes (Knickers)',
        'No',
      ],
      value: '',
    },
    {
      id: '7066471069077380',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '2562871441706884',
      question: 'Would you like to see matching hat designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  softball: [
    {
      id: '5486838445041540',
      question: 'Would you like to see matching pant designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '8561033337956228',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '365685981374340',
      question: 'Would you like to see matching hat/visor designs?',
      options: ['Yes (hats)', 'Yes (visors)', 'No'],
      value: '',
    },
  ],
  basketball: [
    {
      id: '4669084322293636',
      question: 'Would you like to see matching short designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '8439296784918404',
      question: 'Do you want your jerseys/shorts to be reversible?',
      type: 'multiple',
      options: ['Reversible Jerseys', 'Reversible Shorts', 'No'],
      value: '',
    },
    {
      id: '4264390837987204',
      question: 'Would you like to see matching sock designs?',
      options: [true, false],
      value: '',
    },
    {
      id: '5239624608468868',
      question: 'Would you like to see matching shooter shirts?',
      options: ["No",
                "HyperTee Shooter Shirt",
                "HyperMAX Shooter Shirt",
                "NanoZip Shooter Shirt",
                "NanoHood Shooter Shirt"],
      value: '',
    },

  ],
  hockey: [
    {
      id: '8177757779715972',
      question: 'Would you like to see matching shell designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '3576378926884740',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  rugby: [
    {
      id: '6218462418757508',
      question: 'Would you like to see matching shorts designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '5273870261348228',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
  soccer: [
    {
      id: '531753920161668',
      question: 'Would you like to see matching shorts designs?',
      options: ['Yes', 'No'],
      value: '',
    },
    {
      id: '4821372908136324',
      question: 'Would you like to see matching sock designs?',
      options: ['Yes', 'No'],
      value: '',
    },
  ],
};

export const referralOptions = {
  all: [
    'Search Engine (Google, Yahoo. etc.)',
    'Word of Mouth',
    'Opposing Team',
    'Returning Customer',
    'Facebook',
    'ChatGPT',
    'Twitter',
    'Instagram',
    'YouTube',
    'TikTok',
    'Ballparks of America',
    'ABCA',
    'Omaha Baseball Village',
    'LakePoint',
    'MLW',
    'Triton Rays',
    'AC Sports',
    'GMB Baseball',
    'Other',
  ],
  baseball: [
    'Search Engine (Google, Yahoo. etc.)',
    'Word of Mouth',
    'Opposing Team',
    'Returning Customer',
    'Facebook',
    'Twitter',
    'Instagram',
    'YouTube',
    'Triton Rays',
    'Baseball Youth / Softball Youth',
    'Game Day USA',
    'Pastime Baseball',
    'ABCA',
    'Omaha Baseball Village',
    'MLW',
    'Other',
  ],
  soccer: [
    'Search Engine',
    'Word of Mouth',
    'Opposing Team',
    'Returning Customer',
    'Facebook',
    'Twitter',
    'Instagram',
    'Soccer Youth',
    'Other',
  ],
  basketball: [
    'Search Engine (Google, Yahoo, etc.)',
    'Word of Mouth',
    'Opposing Team',
    'Facebook',
    'Twitter',
    'Instagram',
    'Returning Customer',
    'Other',
  ],
  softball: [
    'Search Engine (Google, Yahoo. etc.)',
    'Word of Mouth',
    'Opposing Team',
    'Returning Customer',
    'Facebook',
    'Twitter',
    'Instagram',
    'Softball Youth',
    'NFCA',
    'Other',
  ],
  greek: [
    'Search Engine (Google, Yahoo, etc.)',
    'Word of Mouth',
    'Facebook',
    'Twitter',
    'Instagram',
    'Returning Customer',
    'Other Greek Organization',
    'Other',
  ],
  hockey: [
    'Search Engine',
    'Word of Mouth',
    'Opposing Team',
    'Returning Customer',
    'Facebook',
    'Twitter',
    'Instagram',
    'Other',
  ],
  rugby: [
    'Search Engine',
    'Word of Mouth',
    'Opposing Team',
    'Facebook',
    'Twitter',
    'Instagram',
    'Returning Customer',
    'Other',
  ],
};

export const colorOptions = [
  { name: 'KELLY A1', hex: '#477f01' },
  { name: 'FOREST A2', hex: '#133e11' },
  { name: 'OLIVE B3', hex: '#837500' },
  { name: 'TEAM AMERICA GREEN', hex: '#5c5322' },
  { name: 'LIBERTY GREEN', hex: '#656444' },
  { name: 'PATRIOT GREEN H1', hex: '#747e6d' },
  { name: 'FROG C8', hex: '#69b300' },
  { name: 'LIME A7', hex: '#aec102' },
  { name: 'MINT I7', hex: '#b9d7c1' },
  { name: 'SEAFOAM', hex: '#26cab1' },
  { name: 'LUCKY GREEN A8', hex: '#156252' },
  { name: 'DARK TEAL K6', hex: '#0f5b68' },
  { name: 'AEGEAN BLUE K9', hex: '#1d466b' },
  { name: 'SHARK J9', hex: '#0180ac' },
  { name: 'PARADISE BLUE J2', hex: '#379fd7' },
  { name: 'COLUMBIA J3', hex: '#64b3e4' },
  { name: 'CAROLINA K1', hex: '#9bb1c5' },
  { name: 'BLUE TEAL J1', hex: '#1fa7b8' },
  { name: 'ROYAL K2', hex: '#042696' },
  { name: 'L.A. BLUE', hex: '#02387c' },
  { name: 'ATL BLUE', hex: '#042268' },
  { name: 'NAVY K3', hex: '#000d45' },
  { name: 'PURPLE K4', hex: '#490b61' },
  { name: 'LIGHT PURPLE K8', hex: '#6b347f' },
  { name: 'DARK PINK F9', hex: '#a43a67' },
  { name: 'PINK F3', hex: '#f5879e' },
  { name: 'LIGHT PINK', hex: '#fcabbc' },
  { name: 'PEACH F5', hex: '#fac8be', darkText: true },
  { name: 'LAVENDER I8', hex: '#c4b3e2' },
  { name: 'ORCHID', hex: '#9f5ea2' },
  { name: 'BUBBLEGUM F2', hex: '#fb1e63' },
  { name: 'FIERY CORAL', hex: '#fa654e' },
  { name: 'BRIGHT RED C4', hex: '#fe1700' },
  { name: 'RED D7', hex: '#c81002' },
  { name: 'CARDINAL D6', hex: '#92211f' },
  { name: 'MAROON D3', hex: '#4c0b24' },
  { name: 'GOLD E8', hex: '#f8ba00' },
  { name: 'RAYS GOLD', hex: '#ffa700' },
  { name: 'MT. CODY ORANGE E5', hex: '#f58c43' },
  { name: 'ORANGE E2', hex: '#fd5000' },
  { name: 'BURNT ORANGE E3', hex: '#b84f0d' },
  { name: 'CLAY C9', hex: '#6e2517' },
  { name: 'YELLOW D8', hex: '#f7d700', darkText: true },
  { name: 'OLD GOLD E9', hex: '#cb9500' },
  { name: 'BRASS B8', hex: '#c9ab59' },
  { name: 'VEGAS GOLD F8', hex: '#eac68c', darkText: true },
  { name: 'CREAM K7', hex: '#fbecd4', darkText: true },
  { name: 'KHAKI K5', hex: '#dbba9d' },
  { name: 'BLUE GRAY 90634', hex: '#92999a' },
  { name: 'TACTICAL G1', hex: '#9c8e7c' },
  { name: 'BROWN B5', hex: '#744000' },
  { name: 'COCOA G3', hex: '#9f7b6a' },
  { name: 'BEDROCK G4', hex: '#bc9985' },

  { name: 'DESERT', hex: '#c78f66' },
  { name: 'TAN F4', hex: '#e2b29a' },
  { name: 'IRON GRAY H8', hex: '#363737' },
  { name: 'CHARCOAL H7', hex: '#777777' },
  { name: 'GRAY 30', hex: '#a9a9a9' },
  { name: 'SILVER I3', hex: '#c7c7c7' },
  { name: 'CHROME I4', hex: '#e3e3e0', darkText: true },
  { name: 'BLACK', hex: '#000000' },
  { name: 'WHITE', hex: '#FFFFFF', darkText: true },

  { name: 'blank', hex: '#000000', darkText: true },
  { name: 'NEON YELLOW D8 (+$5)', hex: '#fdfb00', darkText: true },
  { name: 'NEON HIGHLITER B2 (+$5)', hex: '#cbfc36', darkText: true },
  { name: 'NEON PINK F2 (+$5)', hex: '#fd3381', darkText: true },
];
